import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import {
  AppBar,
  Box,
  BottomNavigation,
  BottomNavigationAction,
  Paper,
  Toolbar,
  Typography,
} from '@mui/material';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import PaymentsIcon from '@mui/icons-material/Payments';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import { useTranslation } from 'react-i18next';
import { UserMenu } from './UserMenu';
import { BrandLogo } from '../components/BrandLogo';
import { BRAND } from '../brand';

const TABS = [
  { value: '/me/apontamentos', labelKey: 'menu.timesheet', icon: AccessTimeIcon },
  { value: '/me/vales', labelKey: 'menu.advances', icon: PaymentsIcon },
  { value: '/me/notas-fiscais', labelKey: 'menu.invoices', icon: ReceiptLongIcon },
] as const;

function currentTab(pathname: string): string | false {
  const match = TABS.find((t) => pathname === t.value || pathname.startsWith(`${t.value}/`));
  return match ? match.value : false;
}

export function ColaboradorLayout(): JSX.Element {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const value = currentTab(location.pathname);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <AppBar position="sticky">
        <Toolbar>
          {/* Logo tem fundo branco opaco → badge branco pra assentar na AppBar azul. */}
          <Box sx={{ bgcolor: '#fff', px: 1, py: 0.5, borderRadius: 1, display: 'inline-flex' }}>
            <BrandLogo src={BRAND.logo} height={26} fallbackColor="primary.main" />
          </Box>
          <Box sx={{ flexGrow: 1 }} />
          <Typography variant="caption" component="span" sx={{ mr: 1, opacity: 0.85 }}>
            {t('layout.employeeGreeting')}
          </Typography>
          <UserMenu />
        </Toolbar>
      </AppBar>
      <Box component="main" sx={{ flexGrow: 1, p: 2, pb: 9 }}>
        <Outlet />
      </Box>
      <Paper
        sx={{
          position: 'fixed',
          bottom: 0,
          left: 0,
          right: 0,
          // Fica acima do conteúdo mas abaixo de Modal/Drawer (zIndex.modal = 1300).
          zIndex: (theme) => theme.zIndex.appBar,
        }}
        elevation={3}
      >
        <BottomNavigation
          value={value === false ? null : value}
          onChange={(_e, newValue: string) => navigate(newValue)}
          showLabels
          component="nav"
          aria-label={t('layout.bottomNav')}
        >
          {TABS.map((tab) => {
            const Icon = tab.icon;
            return (
              <BottomNavigationAction
                key={tab.value}
                value={tab.value}
                label={t(tab.labelKey)}
                icon={<Icon />}
              />
            );
          })}
        </BottomNavigation>
      </Paper>
    </Box>
  );
}
